import { Component, OnInit, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { StructureService } from 'src/app/_services';

@Component({
  selector: 'app-ketcher',
  templateUrl: './ketcher.component.html',
  styleUrls: ['./ketcher.component.scss']
})
export class KetcherComponent implements OnInit {
  structQuery: string;
  iframe: any;
  molfile: string;
  svg: any;

  submitSubscription: Subscription;


  constructor(private domSanitizer: DomSanitizer, private structSvc: StructureService, private elRef: ElementRef) {
    this.iframe = this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/ketcherV3/index.html')

        // service to check if molfile returned
    this.submitSubscription = structSvc.molfileAnnounced$.subscribe(molfile => {
      this.molfile = molfile;

      // Try to draw molfile (for when the molfile has changed)
      if (this.molfile) {
        this.setMol(this.molfile);
      }

    })
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.elRef.nativeElement.querySelector("#ketcherFrame").addEventListener('load', this.onLoad.bind(this));
  }

  onLoad(e){
    var iframeDiv = this.elRef.nativeElement.querySelector("#ketcherFrame");
    var iframeDocument = iframeDiv.contentDocument || iframeDiv.contentWindow.document;
    var iframeContent = iframeDocument.querySelectorAll('#canvas');
    this.svg = iframeContent[0];
    var ketcherContent = iframeDocument.querySelectorAll('main > menu');

    this.svg.addEventListener('click', this.onDraw.bind(this));
    this.svg.addEventListener('mousedown', this.onDraw.bind(this));
    this.svg.addEventListener('mouseup', this.onDraw.bind(this));

    if(this.molfile){
      this.setMol(this.molfile);
    }
  }

  onDraw(){
    this.getSmiles();
    this.structSvc.announceSmiles(this.structQuery);
  }

  ngOnDestroy(){
    this.submitSubscription.unsubscribe();
  }

  getKetcher() {
    var frame = null;

    if ('frames' in window && 'ketcherFrame' in window.frames)
      frame = window.frames['ketcherFrame'];
    else
      return null;

    if ('window' in frame)
      return frame.window.ketcher;
  }

  getSmiles() {
    var ketcher = this.getKetcher();

    if (ketcher) {
      this.structQuery = ketcher.getSmiles();
    }
  }

    setMol(inputMol: string) {
    var ketcher = this.getKetcher();

    if (ketcher) {
      if (inputMol.length > 70) {
        ketcher.setMolecule(inputMol)
      } else {
        this.clearStruct();
      };
    }
  }

  clearStruct() {
    let text = this.svg.querySelectorAll("text");
    let path = this.svg.querySelectorAll("path");
    for (let i = 0; i < text.length; i++) {
      text[i].parentNode.removeChild(text[i]);
    }

    for (let j = 0; j < path.length; j++) {
      path[j].parentNode.removeChild(path[j]);
    }
  }

}

